export default __webpack_public_path__ + "static/media/pop-down.cc0a5518.mp3";